export default async function fetchJSON(url, options) {
  const res = await fetch(url, options);
  if (!res.ok) {
    const err = new Error(`fetch ${url} returned ${res.status}`);
    err.res = res;
    throw err;
  }
  const resContentType = res.headers.get('content-type');
  if (resContentType && resContentType.indexOf('application/json') === 0) {
    return res.json();
  }
  return res.text();
}



// WEBPACK FOOTER //
// ./src/fetchJSON.js